export const PUBLIC_EMAIL_DOMAINS: readonly string[] = [
  // Google
  'gmail.com',
  'googlemail.com',

  // Microsoft
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'passport.com',

  // Yahoo
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.co.jp',
  'yahoo.fr',
  'yahoo.de',
  'yahoo.it',
  'yahoo.es',
  'yahoo.ca',

  // Apple
  'icloud.com',
  'me.com',
  'mac.com',

  // Other major providers
  'aol.com',
  'protonmail.com',
  'proton.me',
  'mail.com',
  'zoho.com',
  'yandex.com',
  'yandex.ru',

  // Popular international
  'qq.com', // China
  '163.com', // China
  'sina.com', // China
  'mail.ru', // Russia
  'rambler.ru', // Russia
  'web.de', // Germany
  'gmx.de', // Germany
  'gmx.net',
  'gmx.com',
  'libero.it', // Italy
  'seznam.cz', // Czech Republic

  // Other free services
  'fastmail.com',
  'tutanota.com',
  'tutanota.de',
  'mailbox.org',
  'disroot.org',
  'riseup.net',
] as const;

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID!,
      userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID!,
    },
  },
};
